const cancellationPendingStatus = {
    ALL : -1,

    PENDING : 0

};

angular.module('gw-um-j2js')
    .constant('cancellationPendingStatus', cancellationPendingStatus);